import React from 'react';
import { NotFoundBlock } from '../componets/NotFoundBlock/index.tsx';

export const NotFound: React.FC = () => (
  <div className="container">
      <NotFoundBlock />
    </div>
)